<template>
  <div class="page" id="page-guarantee">

    <div class="section" id="section-guarantee-landing">
      <div class="container">
        <h1>37년간 변함없이<br/>고객 편에서 약속한<br/>5대 보증</h1>
        <p>인슈넷FC 고객이라면<br/>누구보다 전문적이고<br/>체계적인 서비스를 받아야 합니다.</p>
        <div  class="fc-bar"  >
            <div class="left"></div>
            <div class="right"></div>
            <div class="dot"></div>
        </div>
        <div class="tag-list">
          <div class="tag-item">#5대보증</div>
          <div class="tag-item">#비교견적</div>
        </div>
      </div>
    </div>

    <div class="section" id="section-guarantee-introduction">
      <div class="container">
        <div class="section-header">
          <div class="container">
            <element-tab>
              <element-tab-item @click="introductionTab = '최저 보험료'" :on="introductionTab == '최저 보험료'">최저 보험료</element-tab-item>
              <element-tab-item @click="introductionTab = '만기완결 알림'" :on="introductionTab == '만기완결 알림'">만기완결 알림</element-tab-item>
              <element-tab-item @click="introductionTab = '청약철회 환불'" :on="introductionTab == '청약철회 환불'">청약철회 환불</element-tab-item>
              <element-tab-item @click="introductionTab = '착오계약 리콜'" :on="introductionTab == '착오계약 리콜'">착오계약 리콜</element-tab-item>
              <element-tab-item @click="introductionTab = '24시간 근무'" :on="introductionTab == '24시간 근무'">24시간 근무</element-tab-item>
            </element-tab>
          </div>
        </div>
        <div class="section-body">
          <div class="container">

            <div id="introduction-tab-service" v-if="introductionTab == '최저 보험료'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">01</span>최저 보험료 보증</h2>
                  <ul>
                    <li>
                      <p>보증내용</p>
                      고객이 인슈넷FC에서 보험료 견적서를 신청한 후 보험료가 가장 저렴한 보험사를 선택하여 보험을 가입했는데 타사 모집자의 동일한 계약 조건 설계와 비교하여 인슈넷FC의 보험료가 비싸면 <p class="text-blue">초회 보험료 차액의 2배를 보상</p>합니다.
                    </li>
                    <li>
                      <p>유의사항</p>
                      · 보험사, 보험 상품명, 가입일, 가입 조건, 보장 내용, 부가 서비스, 인수 심사 등이 동일한데도 보험료 차액이 발생하면 보상급을 지급합니다.<br/>
                      · 보상급을 신청할 때는 타사 모집자가 발행한 청약 설계서 원본을 제출해야 합니다.
                    </li>
                  </ul>
                  <router-link :to="{ name: 'Service' }" ><button>서비스 신청하기</button></router-link>
                </div>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '만기완결 알림'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">02</span>만기완결 알림 보증</h2>
                  <ul>
                    <li>
                      <p>보증내용</p>
                      고객이 인슈넷FC에서 보험을 가입한 뒤 1년 안에 자동차보험 만기일을 안내해 드리지 않거나 또는 장기 - 생명 보험의 실효일을 안내해 드리지 않는다면 <p class="text-blue">10만원의 위로금을 지급</p>해드립니다.
                    </li>
                    <li>
                      <p>유의사항</p>
                      · 보험 기간이 1년 미만인 자동차보험이나 장기 - 생명 보험을 가입하고 1년이 지난 경우는 보증이 적용되지 않습니다.(중도 해지 계약도 적용 안됨)<br>
                      · 고객의 연락처가 변경되고도 인슈넷FC에 알려주지 않으면 보증이 적용되지 않습니다.<br>
                      · 고객이 부재 중 혹은 통신기기 고장 및 오작동으로 연락받지 못하거나 또는 가족이 대신 연락받은 경우 보증이 적용되지 않습니다.<br>
                    </li>
                  </ul>
                  <router-link :to="{ name: 'Service' }" ><button>서비스 신청하기</button></router-link>
                </div>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '청약철회 환불'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">03</span>청약철회 환불 보증</h2>
                  <ul>
                    <li>
                      <p>보증내용</p>
                      개인인 보험 가입자(법인, 기관, 단체는 보증 대상 아님)가 인슈넷FC에서 보험 가입 후 <p class="text-blue">15일 이내에 가입의사를 철회</p>하고 청약철회에 필요한 서류를 인슈넷FC에 접수하면 보험사가 보험료를 환불하도록 처리해드립니다.
                    </li>
                    <li>
                      <p>유의사항</p>
                      · 인슈넷FC에서 보험 가입 후 철회일 현재 청약이 유효한 개인만 대상입니다.(법인, 기관, 단체는 보증대상이 아님)<br>
                      · 법적 의무 가입 보험(예: 자동차보험의 대인 I, 대물)은 중복 가입한 선 계약이 있는 경우에만 보증 대상이 됩니다.<br>
                      · 보험사 또는 금융감독원이 청약철회 대상에 포함하지 않은 보험 종목은 보증되지 않습니다.<br>
                      · 철회일 이전에 사고 보상금이 청구되면 해당되지 않습니다.<br>
                      · 철회를 신청할 때는 인슈넷FC와 보험사에서 받은 서류, 물품, 금전 일체를 반납해야 합니다.<br>
                    </li>
                  </ul>
                </div>
                <router-link :to="{ name: 'Service' }" ><button>서비스 신청하기</button></router-link>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '착오계약 리콜'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">04</span>착오계약 리콜 보증</h2>
                  <ul>
                    <li>
                      <p>보증내용</p>
                      고객이 인슈넷FC에서 보험을 가입한 뒤 보험사로부터 보험증권을 받았는데 인슈넷FC에서 가입한 청약내용과 보험증권 내용이 다르다면 인슈넷FC에서 가입한 청약 내용으로 보험증권을 발급해 드리고 <p class="text-blue">10만원의 위로금을 지급</p>해드립니다.
                    </li>
                    <li>
                      <p>유의사항</p>
                      · 보상금 청구일 현재 보험 계약이 유효한 경우만 보증 대상입니다.<br>
                      · 타인의 보험증권을 잘못 수령한 경우는 보증 대상이 되지 않습니다.<br>
                      · 보험 가입자 주소 등 보상에 지장 없는 단순 오타는 보증 대상이 되지 않습니다.<br>
                    </li>
                  </ul>
                </div>
                <router-link :to="{ name: 'Service' }" ><button>서비스 신청하기</button></router-link>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '24시간 근무'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">05</span>24시간 근무 보증</h2>
                  <ul>
                    <li>
                      <p>보증내용</p>
                      인슈넷FC에서 자동차보험을 가입한 고객이 1년 365일 어느 때든지 긴급출동이나 교통사고 발생으로 인슈넷FC 대표전화 1668-1100에 전화했으나 센터 담당자와 통화할 수 없었다면 <p class="text-blue">10만원의 보상금을 지급</p>해드립니다.
                    </li>
                    <li>
                      <p>유의사항</p>
                      · 보상금 청구일 현재 자동차보험 계약이 유효한 경우만 보증 대상입니다.<br>
                      · 1시간 이내 3차례 이상 연락이 안되서 고객이 보험사에 긴급출동이나 사고접보를 한 경우 적용됩니다.(인슈넷FC 수신 전화 DB에 고객 발신 전화번호가 저장되고, 보험사 보상 사무소에 서비스 신청이 접수되어야 대상임)<br>
                      · 기상 이변, 다발 사고 등으로 통화 중 대기 후 연락드렸는데도 수신하지 않거나 문자로 안내했는데도 회신이 없거나 또는 통신 사정으로 접속 불량, 통화 두절인 경우에는 적용되지 않습니다.<br>
                    </li>
                  </ul>
                </div>
                <router-link :to="{ name: 'Service' }" ><button>서비스 신청하기</button></router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'tab' ],
  data(){
    return {
      introductionTab: this.$route.query.tab,
    }
  },
  watch: {
    '$route' (n) {
      if(n.name == "Guarantee") {
        if(this.$route.query.tab) {
          this.introductionTab = this.$route.query.tab;
        }
        else {
          this.introductionTab = "최저 보험료";
        }
      }
    },
    'introductionTab' () {
      if(this.introductionTab != this.$route.query.tab){
        this.$router.replace({ 
          hash: `#${document.documentElement.scrollTop}`,
          query: { tab : this.introductionTab }
        })
      }
    }
  },
  methods: {
    fetchTab () {
        if(this.$route.query.tab) {
          this.introductionTab = this.$route.query.tab;
        }
        else {
          this.introductionTab = "최저 보험료";
        }
    }
  },
  mounted() {
    if(this.$route.query.tab) this.introductionTab = this.$route.query.tab;
  },
}
</script>
